import { Box, Button, Modal, ModalBody, ModalContent, ModalOverlay, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import ImageSlider from '../components/PDP/ImageSlider';
import { PDPProps, ProductMedia, ProductVariant, WishlistItemProps } from '../interfaces/components';
import { dispatchAddToCartAnalytics, dispatchViewItemAnalytics } from '../Analytics';
import { LoccitaneClose } from '../Icons/LoccitaneClose';
import { PDPContent } from '../content';
import { PDPWishlist } from '../Icons/PDPWishlist';
import { dispatchCTAClickObject } from '../Analytics';

const PDP = ({
  activeLocale,
  active,
  setActive,
  pdpData,
  productMetaData,
  setToastActive,
  addToWishlist,
}: PDPProps) => {
  const [selectedImage, setSelectedImage] = useState('');
  const [variant, setVariant] = useState<ProductVariant>();

  useEffect(() => {
    const variantData = pdpData?.variants.find((variant: ProductVariant) => variant.default);
    setVariant(variantData);

    const analyticItem = {
      item_id: variantData?.variant_id ? variantData?.variant_id : '',
      item_name: pdpData?.title ? pdpData?.title : '',
      affiliation: '',
      coupon: '',
      discount: 0,
      currency: pdpData?.currency ? pdpData?.currency : '',
      index: 0,
      item_brand: "L'Occitane",
      item_category: variantData?.variants[0]?.value ? variantData?.variants[0]?.value : '',
      item_list_id: '',
      item_list_name: '',
      item_variant: variantData?.variant_id ? variantData?.variant_id : '',
      location_id: '',
      price: parseInt(variantData?.retail_price ? variantData?.retail_price : ''),
      quantity: 1,
    };
    console.log(productMetaData);
    pdpData?.title &&
      pdpData?.title?.length > 0 &&
      dispatchViewItemAnalytics(
        pdpData?.currency ? pdpData?.currency : 'AED',
        variantData?.retail_price ? variantData?.retail_price : '',
        [analyticItem],
        'loccitane',
      );
  }, [pdpData]);

  const onPDPClose = () => {
    setActive(false);
  };

  return (
    <Modal onClose={() => setActive(false)} isOpen={active}>
      <ModalOverlay />
      <ModalContent
        borderRadius="0px"
        m={['0px', '0px', 'auto', 'auto', 'auto']}
        h={['-webkit-fill-available', '-webkit-fill-available', '450px', '500px', '550px']}
        maxW={['100%', '100%', 'fit-content', 'fit-content', 'fit-content']}
        width={['100%', '100%', 'auto', 'auto', 'auto']}
        overflowY={['auto', 'auto', 'unset', 'unset', 'unset']}
        overflowX="hidden"
        position="fixed"
        top="0"
        left="0"
        bottom="0"
        right="0"
      >
        <LoccitaneClose
          position="absolute"
          top={['20px', '30px', '30px', '30px', '30px']}
          right={['20px', '30px', '30px', '30px', '30px']}
          boxSize={[6, 6, 8]}
          cursor="pointer"
          strokeWidth={0.5}
          zIndex={30}
          stroke="#CCCCCC"
          borderRadius="100%"
          _hover={{ stroke: 'black' }}
          transition=".5s"
          onClick={onPDPClose}
        />

        <ModalBody
          height={['auto', 'auto', '400px', '450px', '500px']}
          pointerEvents={active ? 'all' : 'none'}
          padding={['0px', '0px', '22px', '24px', '24px']}
          display="flex"
          flexDirection={['column', 'column', 'row', 'row', 'row']}
          justifyContent={['flex-start', 'flex-start', 'space-between', 'space-between', 'space-between']}
          gap="5"
        >
          <ImageSlider
            activeLocale={activeLocale}
            highlightImage={selectedImage}
            images={variant?.media?.map((productMedia: ProductMedia) => productMedia.url) || []}
            setHighLightImage={(image) => setSelectedImage(image)}
          />
          <Box
            h={['fit-content', 'fit-content', '400px', '450px', '500px']}
            w={['90%', '380px', '250px', '300px', '300px']}
            display="flex"
            flexDirection="column"
            justifyContent="space-evenly"
            margin={['20px auto', '20px auto', '0px', '0px', '0px']}
            padding={['20px', '20px', '20px', '25px', '25px 15px']}
            outline={'4px  solid #FFCB00'}
          >
            <Text
              fontSize={['13px', '13px', '14px', '14px', '14px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoMedium' : 'LoccitaneRegular'}
              fontWeight="400"
              textAlign="center"
              margin={['12px auto', '12px auto', '2px auto', '8px auto', '10px auto']}
            >
              {`${pdpData?.collection}          
              ${
                activeLocale === undefined || !((activeLocale as keyof typeof PDPContent) in PDPContent)
                  ? PDPContent['en'].collection
                  : PDPContent[activeLocale as keyof typeof PDPContent].collection
              }`}
            </Text>
            <Text
              fontSize={['15px', '15px', '15px', '18px', '18px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
              fontWeight="500"
              textAlign="center"
              marginBottom="10px"
            >
              {pdpData?.title}
            </Text>
            <Text
              fontSize={['11px', '11px', '11px', '11px', '12px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
              fontWeight="400"
              textAlign="center"
              padding={['0px 10px', '0px 10px', '0px 0px', '0px 18px', '0px 20px']}
            >
              {pdpData?.short_description}
            </Text>

            <Box
              display="flex"
              flexDirection="column"
              justifyContent="flex-start"
              mt={['20px', '20px', '10px', '20px', '30px']}
              padding={['0px 0px', '0px 0px', '0px 0px', '0px 20px', '0px 20px']}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                borderBottom="1px solid #ccc"
                paddingBottom="5px"
                marginBottom="10px"
              >
                <Text
                  fontSize={['11px', '11px', '12px', '12px', '12px']}
                  fontFamily={'RalewayMedium'}
                  fontWeight="600"
                  textAlign="left"
                >
                  {variant?.variants[0]?.value}
                </Text>
                <Text
                  fontSize={['11px', '11px', '11px', '11px', '12px']}
                  fontFamily={'RalewayMedium'}
                  fontWeight="600"
                  textAlign="end"
                  color="#ccc"
                >
                  {`${pdpData?.currency} ${pdpData?.base_price}`}
                </Text>
              </Box>
              <Box display="flex" justifyContent="space-between" borderBottom="1px solid #ccc" paddingBottom="5px">
                <Text
                  fontSize={['11px', '11px', '11px', '11px', '12px']}
                  fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
                  fontWeight="600"
                  textAlign="left"
                  textTransform="capitalize"
                >
                  {pdpData?.category}
                </Text>
                <Text
                  fontSize={['11px', '11px', '12px', '12px', '12px']}
                  fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
                  fontWeight="600"
                  textAlign="end"
                  color="#ccc"
                >
                  {activeLocale === undefined || !((activeLocale as keyof typeof PDPContent) in PDPContent)
                    ? PDPContent['en'].collection
                    : PDPContent[activeLocale as keyof typeof PDPContent].collection}
                </Text>
              </Box>
            </Box>

            <Box display="flex" flexDirection="column" justifyContent="flex-start">
              <Text
                fontSize={['16px', '17px', '20px', '22px', '22px']}
                fontFamily={'LoccitaneRegular'}
                fontWeight="700"
                textAlign="center"
                margin={['12px auto', '12px auto', '12px auto', '18px auto', '18px auto']}
              >
                {`${pdpData?.currency} ${pdpData?.base_price}`}
              </Text>
            </Box>

            <Box marginTop={['20px', '20px', 'auto', 'auto', 'auto']} w="100%">
              <Button
                leftIcon={<PDPWishlist />}
                bg="white"
                border="1px solid #b7b7b7"
                _hover={{ bg: '#FFCB00', border: '1px solid #FFCB00' }}
                h={['50px', '50px', '40px', '50px', '50px']}
                w="100%"
                margin="0px auto"
                color="black"
                marginTop={['20px', '20px', 'auto', 'auto', 'auto']}
                mb="10px"
                borderRadius="0px"
                onClick={() => {
                  const wishlistItem = {
                    item_id: variant?.variant_id ? variant?.variant_id : '',
                    item_name: pdpData?.title ? pdpData?.title : '',
                    affiliation: '',
                    coupon: '',
                    discount: 0,
                    currency: pdpData?.currency ? pdpData?.currency : '',
                    index: 0,
                    item_brand: "L'Occitane",
                    item_category: variant?.variants[0]?.value ? variant?.variants[0]?.value : '',
                    item_category2: pdpData?.category ? pdpData?.category : '',
                    item_category3: pdpData?.collection ? pdpData.collection : '',
                    item_category4: '',
                    item_category5: pdpData?.base_price ? pdpData?.base_price : '', // should also be price
                    item_list_id: '',
                    item_list_name: '',
                    item_variant: variant?.variant_id ? variant?.variant_id : '',
                    location_id: '',
                    price: parseInt(pdpData?.base_price ? pdpData?.base_price : ''),
                    quantity: 1,
                  };

                  const defaultImage = variant && variant.media.find((media: ProductMedia) => media.main);

                  const wishlistProduct: WishlistItemProps = {
                    product_id: variant?.variant_id ? variant?.variant_id : '',
                    product: wishlistItem,
                    image: defaultImage?.url ? encodeURI(defaultImage?.url) : '',
                    size: variant && variant.variants[0].value ? variant.variants[0].value : '',
                    title: pdpData?.title ? pdpData?.title : '',
                    price: pdpData?.base_price ? pdpData?.base_price : '',
                    currency: pdpData?.currency ? pdpData?.currency : '',
                  };

                  dispatchCTAClickObject(
                    'loccitane',
                    'button',
                    'addToWishlist',
                    wishlistProduct.product_id,
                    pdpData?.default_url ? pdpData.default_url : '',
                  );

                  addToWishlist(wishlistProduct);
                }}
              >
                <Text
                  fontSize={['12px', '12px', '12px', '14px', '14px']}
                  lineHeight={['12px', '12px', '12px', '14px', '14px']}
                  fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
                  fontWeight="600"
                  textAlign="center"
                  textTransform="uppercase"
                >
                  {activeLocale === undefined || !((activeLocale as keyof typeof PDPContent) in PDPContent)
                    ? PDPContent['en'].santaWishlist
                    : PDPContent[activeLocale as keyof typeof PDPContent].santaWishlist}
                </Text>
              </Button>

              <Button
                disabled={variant?.availability !== 'in stock'}
                _disabled={{ bg: 'lightgrey' }}
                bg="#FFCB00"
                _hover={{ bg: 'rgb(255, 203, 0, 0.4)', _disabled: { bg: 'lightgrey', cursor: 'auto' } }}
                h={['50px', '50px', '40px', '50px', '50px']}
                w="100%"
                margin="0px auto"
                color="black"
                borderRadius="0px"
                onClick={() => {
                  const analyticItem = {
                    item_id: variant?.variant_id ? variant?.variant_id : '',
                    item_name: pdpData?.title ? pdpData?.title : '',
                    affiliation: '',
                    coupon: '',
                    discount: 0,
                    currency: pdpData?.currency ? pdpData?.currency : '',
                    index: 0,
                    item_brand: "L'Occitane",
                    item_category: variant?.variants[0]?.value ? variant?.variants[0]?.value : '',
                    item_category2: pdpData?.category ? pdpData?.category : '',
                    item_category3: pdpData?.collection ? pdpData.collection : '',
                    item_category4: '',
                    item_category5: variant?.retail_price ? variant?.retail_price : '', // should also be price
                    item_list_id: '',
                    item_list_name: '',
                    item_variant: variant?.variant_id ? variant?.variant_id : '',
                    location_id: '',
                    price: parseInt(variant?.retail_price ? variant?.retail_price : ''),
                    quantity: 1,
                  };

                  const eventMessage = {
                    event_id: 'add_to_cart',
                    product_id: variant?.variant_id ? variant?.variant_id : '',
                    color_id: '',
                    title: pdpData?.title ? pdpData?.title : '',
                    price: pdpData?.base_price,
                    size_mpn: '',
                    gtin: '',
                  };
                  console.log(eventMessage);
                  window.parent.postMessage(eventMessage, '*');

                  dispatchAddToCartAnalytics(
                    pdpData?.currency ? pdpData?.currency : 'AED',
                    variant?.retail_price ? variant?.retail_price : '',
                    [analyticItem],
                    'loccitane',
                  );

                  setToastActive('Item Added to Cart');
                }}
              >
                <Text
                  fontSize={['12px', '12px', '12px', '14px', '14px']}
                  lineHeight={['12px', '12px', '12px', '14px', '14px']}
                  fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
                  fontWeight="600"
                  textAlign="center"
                  textTransform="uppercase"
                >
                  {activeLocale === undefined || !((activeLocale as keyof typeof PDPContent) in PDPContent)
                    ? PDPContent['en'].addToCart
                    : PDPContent[activeLocale as keyof typeof PDPContent].addToCart}
                </Text>
              </Button>
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default PDP;
